export const TOPIC_ANALYTICS_API_ROUTES = {
    SKILL_ANALYSIS: '/test/skillAnalysis',
}